import validateParseAdClickTracker from './parseAdClickTracker.validator';
import validateExt from './parseExt.validator';

export const adParsing = {
  validateParseAdClickTracker,
  validateExt,
};
